import { render, staticRenderFns } from "./UsersBotItem.vue?vue&type=template&id=ae3b4538&scoped=true&"
import script from "./UsersBotItem.vue?vue&type=script&lang=js&"
export * from "./UsersBotItem.vue?vue&type=script&lang=js&"
import style0 from "./UsersBotItem.vue?vue&type=style&index=0&id=ae3b4538&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3b4538",
  null
  
)

export default component.exports